/**
 * DiceBear Avatar Utility
 * Generates consistent, colorful avatars for users without profile pictures.
 */

export const getAvatarUrl = (seed: string | null | undefined, style: 'initials' | 'identicon' | 'bottts' = 'initials') => {
    if (!seed) return '';

    // Clean seed and use as identifier
    const identifier = seed.trim().toLowerCase();

    // Return DiceBear API URL
    return `https://api.dicebear.com/9.x/${style}/svg?seed=${encodeURIComponent(identifier)}&backgroundColor=0070a1,00a1d4,004d7a&backgroundType=gradientLinear&fontSize=40&fontWeight=600`;
};
